import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SocialMediaSection.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const SocialMediaSection = () => {
  const [socialLinks, setSocialLinks] = useState({
    facebook: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    youtube: '',
    github: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSocialLinks();
  }, []);

  const fetchSocialLinks = async () => {
    try {
      const response = await axios.get(`${API_URL}/landing_page_api.php`);
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};
        setSocialLinks({
          facebook: config.social_facebook || '',
          twitter: config.social_twitter || '',
          linkedin: config.social_linkedin || '',
          instagram: config.social_instagram || '',
          youtube: config.social_youtube || '',
          github: config.social_github || ''
        });
      }
    } catch (error) {
      console.error('Failed to fetch social links:', error);
    } finally {
      setLoading(false);
    }
  };

  // Get social media icon and name mapping
  const socialPlatforms = [
    { key: 'facebook', icon: 'fab fa-facebook-f', name: 'Facebook', color: '#1877F2' },
    { key: 'twitter', icon: 'fab fa-twitter', name: 'Twitter', color: '#1DA1F2' },
    { key: 'linkedin', icon: 'fab fa-linkedin-in', name: 'LinkedIn', color: '#0A66C2' },
    { key: 'instagram', icon: 'fab fa-instagram', name: 'Instagram', color: '#E4405F' },
    { key: 'youtube', icon: 'fab fa-youtube', name: 'YouTube', color: '#FF0000' },
    { key: 'github', icon: 'fab fa-github', name: 'GitHub', color: '#181717' }
  ];

  // Filter only platforms with URLs configured
  const activePlatforms = socialPlatforms.filter(platform => socialLinks[platform.key]);

  // Don't render if no social links are configured
  if (loading || activePlatforms.length === 0) {
    return null;
  }

  return (
    <section className="social-media-section">
      <div className="container">
        <div className="social-media-content">
          <div className="social-header">
            <h2>Follow Us</h2>
            <p>Stay connected and get the latest updates</p>
          </div>

          <div className="social-icons-grid">
            {activePlatforms.map(platform => (
              <a
                key={platform.key}
                href={socialLinks[platform.key]}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-link"
                aria-label={platform.name}
                title={platform.name}
              >
                <div className="social-icon-wrapper">
                  <i className={platform.icon}></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;
